import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from 'react';
import styles from '../styles/MultiFilePreview.module.css';
import { fileData, fData } from "@/components/Upload/utils/file-thumbnail";
import FileThumbnail from "@/components/Upload/components/FileThumbnail";
import { DeleteButton } from "@/components/Upload/components/DeleteButton";
import { useTranslation } from "@i18n";
import LinkToFile from "@/common/HOCs/LinkToFile";
var MultiFilePreview = function MultiFilePreview(_ref) {
  var sx = _ref.sx,
    _onRemove = _ref.onRemove,
    lastNode = _ref.lastNode,
    thumbnail = _ref.thumbnail,
    slotProps = _ref.slotProps,
    firstNode = _ref.firstNode,
    _ref$files = _ref.files,
    files = _ref$files === void 0 ? [] : _ref$files,
    _ref$enablePreview = _ref.enablePreview,
    enablePreview = _ref$enablePreview === void 0 ? false : _ref$enablePreview;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderFirstNode = firstNode && /*#__PURE__*/React.createElement("li", {
    className: thumbnail ? styles.listItemImageView : ''
  }, firstNode);
  var renderLastNode = lastNode && /*#__PURE__*/React.createElement("li", {
    className: thumbnail ? styles.listItemImageView : ''
  }, lastNode);
  return /*#__PURE__*/React.createElement("ul", {
    className: "".concat(styles.multiFilePreview, " ").concat(thumbnail ? styles.multiFilePreviewThumbnail : ''),
    style: sx
  }, renderFirstNode, files.map(function (file) {
    var _fileData = fileData(file),
      name = _fileData.name,
      size = _fileData.size;
    if (thumbnail) {
      return /*#__PURE__*/React.createElement("li", {
        key: name,
        className: styles.listItemThumbnail
      }, /*#__PURE__*/React.createElement(FileThumbnail, _extends({
        imageView: true,
        file: file,
        onRemove: function onRemove() {
          return _onRemove === null || _onRemove === void 0 ? void 0 : _onRemove(file);
        },
        className: styles.listItemThumbnail,
        slotProps: {
          icon: {
            width: 28,
            height: 28
          }
        }
      }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.thumbnail)));
    }
    return /*#__PURE__*/React.createElement("li", {
      key: name,
      className: styles.listItem
    }, /*#__PURE__*/React.createElement(FileThumbnail, _extends({
      file: file
    }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.thumbnail)), /*#__PURE__*/React.createElement("div", {
      className: styles.contentBox
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: styles.fileName
    }, name), /*#__PURE__*/React.createElement("p", {
      className: styles.fileSize
    }, fData(size))), /*#__PURE__*/React.createElement("div", {
      className: styles.previewBox
    }, /*#__PURE__*/React.createElement("span", null, enablePreview && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkToFile, {
      domInMemoryFile: file,
      renderFunc: function renderFunc(label, onClick) {
        return /*#__PURE__*/React.createElement("a", {
          onClick: onClick,
          target: "_blank",
          rel: "noreferrer",
          className: styles.previewLink
        }, label);
      }
    }))), _onRemove && /*#__PURE__*/React.createElement("span", {
      className: styles.deleteButton
    }, /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: function onClick() {
        return _onRemove(file);
      }
    })))));
  }), renderLastNode);
};
export default MultiFilePreview;